<template lang="pug">
div
    div(v-if="isLoading")
        Loader
    div(v-else)
        div.d-flex.justify-content-between.align-items-end.flex-wrap.mb-3
            h3 Active Intake {{intake_assessments.length > 1 ? 'Requests' : 'Request'}}
                b-badge.ml-2 {{intake_assessments.length > 0 ? intake_assessments.length : 0}}
            b-input-group.w-50
                b-form-input(id="filter-input" v-model="filter" type="search" placeholder="Search" debounce="500")
                <b-input-group-append is-text>
                    <b-icon icon="search"></b-icon>
                </b-input-group-append>

        div(v-if="intake_assessments.length > 0")
            b-table(:items="intake_assessments", :fields="fields" :filter="filter" :per-page="perPage" :current-page="currentPage" stacked='md')
                template(#cell(new_Client.new_name)='data')
                    b {{data.item.new_Client.new_name}}
                    div
                        | {{data.item.new_Client.new_race === 100000000 ? 'Chinese' : ''}}
                        | {{data.item.new_Client.new_race === 100000001 ? 'Malay' : ''}}
                        | {{data.item.new_Client.new_race === 100000002 ? 'Indian' : ''}}
                        | {{data.item.new_Client.new_race === 100000003 ? data.item.new_Client.new_raceother : ''}}
                        | {{data.item.new_Client.new_gender === 100000000 ? 'Male,' : ''}}
                        | {{data.item.new_Client.new_gender === 100000001 ? 'Female,' : ''}}
                    div {{data.item.new_Client.new_age}}
                template(#cell(type)='data')
                    | {{data.item.new_admissiontype === 100000000 ? 'General, Individual' : ''}}
                    | {{data.item.new_admissiontype === 100000001 ? 'General, Family' : ''}}
                    | {{data.item.new_admissiontype === 100000002 ? 'Ex-Offender' : ''}}
                template(#cell(createdon)='data')
                    | {{ dayjs(data.item.createdon).format('DD/MM/YYYY') }}
                template(#cell(new_personincharge)='data')
                    div.font-weight-bold {{ (data.item.new_personincharge in userGraphName) ? userGraphName[data.item.new_personincharge] : 'N/A' }}
                    div {{dayjs(data.item.new_applicationacknowledgementdate).format('DD/MM/YYYY')}}
                template(#cell(new_intakestatus)='data')
                    | {{data.item.new_intakestatus === 100000000 ? 'Pending' : ''}}
                    small.d-flex.text-muted(v-if="data.item.new_intakestatus === 100000001") {{dayjs(data.item.new_applicationacknowledgementdate).format('DD/MM/YYYY')}}
                    | {{data.item.new_intakestatus === 100000001 ? `Under Review` : ''}}
                    small.d-flex.text-muted(v-if="data.item.new_intakestatus === 100000002 || data.item.new_intakestatus === 100000003") {{dayjs(data.item.new_cttoutcomedate).format('DD/MM/YYYY')}}
                    | {{data.item.new_intakestatus === 100000002 ? 'Pending Accept' : ''}}
                    | {{data.item.new_intakestatus === 100000003 ? 'Pending Reject' : ''}}
                    small.d-flex.text-muted(v-if="data.item.new_intakestatus === 100000004 || data.item.new_intakestatus === 100000005") {{dayjs(data.item.new_shelteroutcomedate).format('DD/MM/YYYY')}}
                    | {{data.item.new_intakestatus === 100000004 ? 'Accepted' : ''}}
                    | {{data.item.new_intakestatus === 100000005 ? 'Rejected' : ''}}
                    span(v-if="data.item.new_intakestatus === 100000002 || data.item.new_intakestatus === 100000003")
                        | from {{ (data.item.new_approverassigned in userGraphName) ? userGraphName[data.item.new_approverassigned] : 'N/A' }}
                template(#cell(actions)="data")
                    <b-button size="sm" class="mr-1" :to="'/intake/'+(data.item.new_intakeassessmentid)">View Details</b-button>

            b-pagination.m-0(
                v-model="currentPage"
                :total-rows="intake_assessments.length"
                :per-page="perPage"
            )
        div(v-else)
            p No active intake.
</template>

<script>
import dayjs from 'dayjs';
import Loader from '@/components/loader/Loading.vue';

export default {
    name: 'ActiveIntakeList',
    props: {
        forUser: {
            type: Boolean,
        }
    },
    components: {
        Loader,
    },
    data(){
        return{
            isLoading: true,
            filter: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            fields:[
                { key: 'new_Client.new_name', label: 'Name', sortable: true },
                'type',
                { key: 'createdon', label: 'Application Date', sortable: true },
                { key: 'new_personincharge', label: 'Handled By', sortable: true },
                { key: 'new_intakestatus', label: 'Status', sortable: true },
                'actions'
            ],
            // store converted graph id to name
            userGraphName: {}
        }
    },
    computed: {
        intake_assessments(){
            return this.$store.state.active_intake_assessments.value;
        }
    },
    async mounted() {
        let isSuccess = false;
        if(this.forUser) {
            isSuccess = await this.fetchUserIntakeAssessments();
        }
        else {
            isSuccess = await this.fetchIntakeAssessments();
        }

        if(!isSuccess) {return;}

        // convert graph id user to name
        for(let intake of this.intake_assessments) {
            if(!(intake.new_personincharge in this.userGraphName)) {
                this.userGraphName[intake.new_personincharge] = await this.getNameByGraphId(intake.new_personincharge);
            }

            if(!(intake.new_approverassigned in this.userGraphName)) {
                this.userGraphName[intake.new_approverassigned] = await this.getNameByGraphId(intake.new_approverassigned);
            }
        }

        this.totalRows = this.intake_assessments.length; // set no of rows for pagination
        this.isLoading = false;
    },
    methods: {
        dayjs,
        async fetchIntakeAssessments() {
            return await this.$store.dispatch('fetchAllIntakeAssessment', {status:'active'}).then(()=>{
                return true;
            }).catch((err)=>{
                // do something
                window.alert(err?.response?.data?.error || 'Something when wrong when loading intake.');
                return false;
            })
        },
        async fetchUserIntakeAssessments() {
            return await this.$store.dispatch('fetchUserIntakeAssessment', {status:'active'}).then(()=>{
                return true;
            }).catch((err)=>{
                // do something
                window.alert(err?.response?.data?.error || 'Something when wrong when loading intake.');
                return false;
            })
        },
        async getNameByGraphId(graphId) {
            if(!graphId) {return 'N/A';}

            return await this.$store.dispatch('getUserByGraphId', graphId).then((result)=>{
                return result.graph_display_name;
            }).catch(()=>{
                return 'N/A';
            })
        }
    }
}
</script>

<style lang="scss">

</style>